import {InventoryValidationErrorLabel} from 'inventory/InventoryConstants';
import {inventoryValidationErrorLabelToDisplayText} from 'inventory/location-validation/ParentStorableValidationUtils';
import {OptionData} from 'ui-library/menus/MenuConstants';

export function getInventoryValidationErrorLabelMenuOptionDatas(): Promise<Array<OptionData>> {
  return Promise.resolve(
    [
      InventoryValidationErrorLabel.OVER_CAPACITY,
      InventoryValidationErrorLabel.ITEM_TYPES_DISALLOWED,
      InventoryValidationErrorLabel.NON_LOCATION_ITEMS_DISALLOWED,
    ].map((errorLabel) => ({
      value: errorLabel,
      name: inventoryValidationErrorLabelToDisplayText(errorLabel),
    }))
  );
}
